import React, { useEffect, useState } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/MasterFiling.css";

const MasterFiling = () => {
  const [workers, setWorkers] = useState([]);
  const [items, setItems] = useState([]);
  const [selectedWorker, setSelectedWorker] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [pcs, setPcs] = useState("");
  const [ongoingLots, setOngoingLots] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  const [popupLot, setPopupLot] = useState(null);
  const [receivedPcs, setReceivedPcs] = useState("");
  const [rate, setRate] = useState("");

  useEffect(() => {
    fetchWorkers();
    fetchItems();
    fetchOngoingLots();
  }, []);

  // ✅ FIX WORKERS (correct column = worker_name)
  const fetchWorkers = async () => {
    const { data } = await supabase.from("WORKERS").select("*").eq("status", true);
    setWorkers(data || []);
  };

  // ✅ FIX ITEMS
  const fetchItems = async () => {
    const { data } = await supabase.from("ITEMS").select("*").eq("status", true);
    setItems(data || []);
  };

  // ✅ FIX LOT LOADING
  const fetchOngoingLots = async () => {
    const { data } = await supabase
      .from("MASTER_ISSUE")
      .select("*")
      .eq("status", "pending");
    setOngoingLots(data || []);
  };

  // ISSUE LOT
  const handleIssue = async () => {
    if (!selectedWorker || !selectedItem || !pcs) {
      alert("Please fill all fields");
      return;
    }

    await supabase.from("MASTER_ISSUE").insert([
      {
        worker_id: selectedWorker,
        item_id: selectedItem,
        pcs,
        status: "pending",
      },
    ]);

    setSelectedWorker("");
    setSelectedItem("");
    setPcs("");
    fetchOngoingLots();
  };

  // OPEN RECEIVE POPUP
  const openReceivePopup = (lot) => {
    setPopupLot(lot);
    setReceivedPcs("");
    setRate("");
    setShowPopup(true);
  };

  // SUBMIT RECEIVE
  const submitReceive = async () => {
    if (!receivedPcs || !rate) {
      alert("Enter received pcs & rate");
      return;
    }

    const rejected = popupLot.pcs - receivedPcs;
    const amount = receivedPcs * rate;

    await supabase.from("MASTER_RECEIVE").insert([
      {
        issue_id: popupLot.id,
        received_pcs: receivedPcs,
        rejected_pcs: rejected,
        rate_per_pc: rate,
        amount,
        status: "COMPLETED",
      },
    ]);

    await supabase.from("MASTER_ISSUE").update({ status: "COMPLETED" }).eq("id", popupLot.id);

    setShowPopup(false);
    setPopupLot(null);
    fetchOngoingLots();
  };

  return (
    <div className="master-page">
      <div className="master-card">
        <h2 className="master-title">🛠️ Master Filing</h2>

        <label>Select Worker</label>
        <select
          value={selectedWorker}
          onChange={(e) => setSelectedWorker(e.target.value)}
        >
          <option value="">Select Worker</option>
          {workers.map((w) => (
            <option key={w.id} value={w.id}>
              {w.worker_name}
            </option>
          ))}
        </select>

        <label>Select Item</label>
        <select
          value={selectedItem}
          onChange={(e) => setSelectedItem(e.target.value)}
        >
          <option value="">Select Item</option>
          {items.map((i) => (
            <option key={i.id} value={i.id}>
              {i.item_name}
            </option>
          ))}
        </select>

        <label>Enter PCS</label>
        <input
          type="number"
          value={pcs}
          onChange={(e) => setPcs(e.target.value)}
        />

        <button className="gold-btn" onClick={handleIssue}>
          ➕ Issue
        </button>
      </div>

      <div className="ongoing-card">
        <h3 className="ongoing-title">📌 Ongoing Lots</h3>

        {ongoingLots.length === 0 ? (
          <p>No ongoing lots</p>
        ) : (
          ongoingLots.map((lot) => (
            <div className="lot-row" key={lot.id}>
              <span>
                🔹 Lot #{lot.id.slice(-6).toUpperCase()} — {lot.pcs} pcs
              </span>

              <button className="receive-btn" onClick={() => openReceivePopup(lot)}>
                Receive
              </button>
            </div>
          ))
        )}
      </div>

      {showPopup && popupLot && (
        <div className="popup-overlay">
          <div className="popup-card">
            <h3 className="popup-title">
              Receive Lot #{popupLot.id.slice(-6).toUpperCase()}
            </h3>

            <label>Received PCS</label>
            <input
              type="number"
              value={receivedPcs}
              onChange={(e) => setReceivedPcs(e.target.value)}
            />

            <label>Rate Per PC</label>
            <input
              type="number"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />

            <div className="auto-box">
              <p>
                Rejected PCS: <b>{popupLot.pcs - (receivedPcs || 0)}</b>
              </p>
              <p>
                Amount: <b>{receivedPcs && rate ? receivedPcs * rate : 0}</b>
              </p>
            </div>

            <div className="popup-actions">
              <button className="gold-btn full-btn" onClick={submitReceive}>
                Submit
              </button>
              <button className="cancel-btn full-btn" onClick={() => setShowPopup(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MasterFiling;
